/**
 * Datos maestros del sitio: identidad, contacto, navegación y
 * señales de confianza. Un solo lugar para actualizar todo lo
 * que se repite en la página.
 */

export const SITE = {
  name: "Financial Support Group Inc.",
  shortName: "FSG Seguros",
  url: "https://www.fsgseguros.com",
  logo: "/logo192.png",
  ogImage: "/images/banner.jpeg",
  tagline: {
    es: "Si se trata de seguros, tu familia y la mía son solo una",
    en: "When it comes to insurance, your family and mine are one",
  },
  phone: "+1-787-658-6122",
  phoneDisplay: "787-658-6122",
  whatsapp: "17872334871",
  whatsappDisplay: "787-233-4871",
  email: "0ffice@fsgseguros.com",
  address: {
    street: "10000 Carr. 2",
    city: "Quebradillas",
    district: "Barrio Cocos",
    zip: "00678",
    full: "10000 Carr. 2, Barrio Cocos, Quebradillas, Puerto Rico 00678",
  },
  hours: {
    es: "Lunes a viernes, 8:30 a. m. – 5:30 p. m.",
    en: "Monday to Friday, 8:30 a. m. – 5:30 p. m.",
  },
  social: {
    facebook: "https://facebook.com/segurosfsg",
    instagram: "https://instagram.com/fsg_seguros",
  },

  /** Formulario de solicitud de empleo de «Únete a FSG». */
  joinFormUrl: "https://forms.office.com/r/ZPVTj99PPz",
};

/** Navegación principal: ancla dentro de la misma página. */
export const NAV = [
  {
    id: "productos",
    label: { es: "Productos", en: "Products" },
    mega: true,
  },
  { id: "herramientas", label: { es: "Herramientas", en: "Tools" } },
  { id: "testimonios", label: { es: "Testimonios", en: "Testimonials" } },
  { id: "unete", label: { es: "Únete a FSG", en: "Join FSG" } },
];

/** Orden real de las secciones en la página principal (para el scrollspy). */
export const SECTION_IDS = [
  "inicio",
  "por-que-elegirnos",
  "productos",
  "herramientas",
  "testimonios",
  "faq",
  "contacto",
];

/** Enlaces legales del footer (se abren como modal de texto). */
export const LEGAL_LINKS = [
  { id: "privacidad", label: { es: "Privacidad", en: "Privacy" } },
  { id: "terminos", label: { es: "Términos de uso", en: "Terms of use" } },
  { id: "avisos", label: { es: "Avisos importantes", en: "Disclosures" } },
];
